import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import './DesktopNotification.css';

export default function DesktopNotification({
  className,
  notificationId,
  title,
  content,
  footer,
  iconSrc,
  onClose,
  disabled
}) {
  const handleClose = useCallback(
    () => onClose(notificationId),
    [onClose, notificationId]
  );
  if (disabled) {
    return <div className={`desktop-notification ${className}`} />;
  }
  return (
    <div className={`desktop-notification ${className}`}>
      <button
        className="desktop-notification-close-button"
        onClick={handleClose}
        type="button"
        aria-label="Close Notification"
      >
        <span>✖</span>
      </button>
      <div className="desktop-notification-title">{title}</div>
      <div className="desktop-notification-body">
        {iconSrc && (
          <div className="desktop-notification-icon">
            <img src={iconSrc} alt="" />
          </div>
        )}
        <div className="desktop-notification-content">{content}</div>
      </div>
      {footer && <div className="desktop-notification-footer">{footer}</div>}
    </div>
  );
}

DesktopNotification.propTypes = {
  notificationId: PropTypes.number.isRequired,
  title: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  content: PropTypes.node,
  footer: PropTypes.node,
  iconSrc: PropTypes.string,
  disabled: PropTypes.bool
};

DesktopNotification.defaultProps = {
  className: '',
  disabled: false
};
